import { attach } from 'effector';

import { api } from '@shared/api/api';

const resetPasswordFx = attach({
  effect: api.auth.completeNewPasswordChallenge
});

export { resetPasswordFx };
